'use strict';
  
  /**
   * Pushes a new event entry to a global data layer and dispatches a custom event.
   * This function ensures the `window.spsDataLayer` object and its `events` array
   * exist before adding the new event, making it safe to call at any time.
   * It also dispatches a custom browser event to notify other parts of the application
   * that a new event has been added.
   *
   * @param {object} dataLayerEventEntry - The event object to be added to the data layer.
   */	
  function pushAfterInit(dataLayerEventEntry) {
		
    // add Event to TrackingStore
    if (!window.spsTrackingStore || !window.spsTrackingStore.isReady()) {
        document.addEventListener('wt-ready', function () {
        window.spsTrackingStore.add(dataLayerEventEntry.global.eventType, dataLayerEventEntry);
    });
    } else {
        window.spsTrackingStore.add(dataLayerEventEntry.global.eventType, dataLayerEventEntry);
    }
  
  };

  /**
  * Initializes a document-level event listener to intercept and process AJAX responses.
  * This function uses jQuery's `ajaxComplete` event to check if the incoming
  * AJAX response contains a specific data layer object and, if so, pushes it
  * to the global data layer.
  *
  * @requires jQuery
  */
  function init() {
    
    $( document ).ajaxComplete(function( event, jqXHR, ajaxOptions ) {

      const contentType = jqXHR.getResponseHeader('Content-Type') || '';
      try 
      {

        if (contentType.includes("text/html")) {

              const tempDiv = document.createElement('div');
              tempDiv.innerHTML = jqXHR.responseText;

              try {
                const criteoPLPTag = tempDiv.querySelector('script[type="application/json"]#spsDataLayerCriteoPLPUpdate');
                
                if (criteoPLPTag) {
                  var criteoPLPUpdate = JSON.parse(criteoPLPTag.textContent);

                  const criteoPlp = window.spsDataLayer?.ThirdParty?.criteo?.plp;

                  if (criteoPlp && typeof criteoPLPUpdate !== 'undefined' && criteoPLPUpdate !== null) {
                    criteoPlp.category = criteoPLPUpdate.category ?? criteoPlp.category;
                    criteoPlp.filters  = criteoPLPUpdate.filters  ?? criteoPlp.filters;
                    criteoPlp.parentItem = criteoPLPUpdate.parentItem ?? criteoPlp.parentItem;
                    criteoPlp.pageNumber  = criteoPLPUpdate.pageNumber  ?? criteoPlp.pageNumber;
                    criteoPlp.listSize  = criteoPLPUpdate.listSize  ?? criteoPlp.listSize;
                    if (typeof window.initCriteoTracking === 'function') {
                      window.initCriteoTracking(window.spsDataLayer.ThirdParty.criteo);
                    } else {
                      window.criteoIsReadyToStart = true;
                    }
                  }
                }
              } catch (error) {
                // do nothing
              }

              const jsonScriptTag = tempDiv.querySelector('script[type="application/json"]#spsDataLayerEvent');
              pushAfterInit(JSON.parse(jsonScriptTag.textContent));
          
            } else if (contentType.includes("application/json")) {

              const responseData = jqXHR.responseJSON || JSON.parse(jqXHR.responseText);
      
              if (typeof responseData === 'object' && responseData !== null && responseData.hasOwnProperty('spsDataLayer')) {
                pushAfterInit(responseData.spsDataLayer);
              }
          }
      } catch (e) {
        // do nothing
      }

    });
  }

  init();

module.exports = () => {
  pushAfterInit: pushAfterInit
};